export default __webpack_public_path__ + "static/media/logo-gold.f1ca93fd.svg";